/** Role helpers shared across the console. */

type MeLike =
  | { roles?: string[] | null; landlord_id?: string | null }
  | null
  | undefined;

/** Landlord-portal guests get the restricted experience (server enforces; UI follows). */
export function isLandlord(me: MeLike): boolean {
  return Boolean(me?.landlord_id || me?.roles?.includes("landlord"));
}
